import { render, staticRenderFns } from "./Adminitration_Recipes_Item.vue?vue&type=template&id=714c2c58"
import script from "./Adminitration_Recipes_Item.vue?vue&type=script&lang=js"
export * from "./Adminitration_Recipes_Item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports